// @flow
export const ORG_VALUES_CREATE_FORM = 'ORG_VALUES_CREATE_FORM'
export const ORG_VALUES_EDIT_FORM = 'ORG_VALUES_EDIT_FORM'
